import * as Schema from 'generated/graphql/schema';
import { FunctionComponent, useContext } from 'react';

import AndonLundbeckResolveCallDialog from '@/components/dialogs/andon/call-interaction/lundbeck-resolve-call';
import AndonPendingCallDialog from '@/components/dialogs/andon/call-interaction/pending-call';
import AndonReopenCallDialog from '@/components/dialogs/andon/call-interaction/reopen-call';
import AndonResolveCallDialog from '@/components/dialogs/andon/call-interaction/resolve-call';
import AndonTakeCallDialog from '@/components/dialogs/andon/call-interaction/take-call';
import { COMPANIES } from '@/constants';
import { Context as CompanyContext } from '@/contexts/company';
import * as Types from '@/types';

export interface Properties {
  call: Schema.AndonListCallsQuery['andon'][0]['calls'][0];
  open: boolean;
  handleOpenClose(): void;
}

const callStates: Array<keyof Types.Andon.ExtendedCall['action']> = ['resolve', 'pending', 'take', 'make'];
const AndonCallDialog: FunctionComponent<Properties> = ({ call, open, handleOpenClose }) => {
  const { companyId } = useContext(CompanyContext);

  if (!call || !open) {
    return null;
  }

  const currentAction = callStates.find((state) => {
    return !!call.action[state];
  });

  const requireWorkOrder = companyId === COMPANIES.LUNDBECK && !!call.tags?.length;

  switch (currentAction) {
    case 'resolve':
      return <AndonReopenCallDialog call={call} onClose={handleOpenClose} frozen={!!call.action.pending} />;
    case 'pending':
      return <AndonPendingCallDialog call={call} onClose={handleOpenClose} />;
    case 'take':
      if (requireWorkOrder) {
        return <AndonLundbeckResolveCallDialog call={call} onClose={handleOpenClose} />;
      } else {
        return <AndonResolveCallDialog call={call} onClose={handleOpenClose} />;
      }
    case 'make':
      return <AndonTakeCallDialog call={call} onClose={handleOpenClose} requireInitials={requireWorkOrder} />;
    default:
      return <>noop</>;
  }
};

export default AndonCallDialog;
